import { hexToRgbaCss } from 'core/utils/colorHelpers'
import colors from '../base/colors'

export const defaultAlertComponentStyles = {
  primary: {
    background: hexToRgbaCss(colors.blue[500], 0.05),
    border: colors.blue[500],
  },
  success: {
    background: hexToRgbaCss(colors.green[500], 0.05),
    border: colors.green[500],
  },
  warning: {
    background: hexToRgbaCss(colors.orange[500], 0.05),
    border: colors.orange[500],
  },
  error: {
    background: hexToRgbaCss(colors.red[500], 0.05),
    border: colors.red[500],
  },
}

// Banner tones from the PCD Component Library (Figma "Banner - Inline").
// Hex values without an exact match in the base palette are inlined.
export const defaultBannerComponentStyles = {
  neutral: {
    text: colors.grey[700],
    border: colors.grey[900],
    background: colors.grey[200],
    subtleBackground: colors.grey[150],
  },
  informative: {
    text: colors.blue[900],
    border: colors.blue[900],
    background: '#cae4f2',
    subtleBackground: colors.blue[150],
  },
  success: {
    text: '#0a7a5e',
    border: '#0a7a5e',
    background: '#e7f4f1',
    subtleBackground: colors.green[150],
  },
  warning: {
    text: '#966a00',
    border: '#966a00',
    background: '#fef7e6',
    subtleBackground: colors.yellow[150],
  },
  error: {
    text: '#931700',
    border: '#931700',
    background: '#ffeeeb',
    subtleBackground: colors.red[150],
  },
}

export const defaultGraphComponentStyles = {
  unknown: colors.grey[300],

  primary: colors.blue[500],
  fadedPrimary: colors.blue[300],

  success: colors.green[500],
  fadedSuccess: colors.green[300],

  warning: colors.yellow[500],
  fadedWarning: colors.yellow[200],

  danger: colors.orange[500],
  fadedDanger: colors.yellow[300],

  error: colors.red[500],
  fadedError: colors.red[300],

  aws: colors.aws[500],
  azure: colors.azure[500],
  google: colors.googleYellow[500],
}

export const defaultCodeComponentStyles = {
  background: colors.grey[50],
  text: colors.grey[700],
  border: colors.grey[200],
}
